import { Component, OnInit } from '@angular/core';
import { LookupScreenService } from '../../../../../../services/lookup-screen.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';
import { DoctorBreadcrumbService } from '../../../../shared/breadcrumb.service';
import { TraceClassDecorator } from '@sentry/angular';
import { searchBody } from '../lookup-search-d/lookup-search-d.component';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@TraceClassDecorator()
@Component({
    selector: 'app-lookup-list-d',
    templateUrl: './lookup-list-d.component.html',
    styleUrls: [
        './lookup-list-d.component.css',
        '../../../../../../../assets/css/custom-egd.css'
    ]
})
export class LookupListDComponent implements OnInit {
    body: any;

    gtype: any;
    lookuplist;
    multirecord: any;
    selectedDoctor;
    type;
    data: string;
    e;
    first = 1;
    gpageNo = 0;
    pageno;
    rows = 1;
    slug: string = "";
    totalRecords: number;
    loading: boolean = false;
    cols: any[];
    searchbody1: searchBody = {
        current_user_guid: '',
        records_per_page: 0,
        page_no: 0
    };

    constructor(
        private lookupservice: LookupScreenService,
        private router: Router,
        private route: ActivatedRoute,
        private breadcrumbService: DoctorBreadcrumbService,
        private readonly providerstateService: ProviderStateService
    ) {

    }

    getpage(gtype, gdata, grow: number = 1, first: number = 1) {
        this.pageno = (first - 1) / grow + 1;
        switch (gtype) {
            case 'email':
                this.body = {
                    e_email: gdata,
                    records_per_page: grow.toString(),
                    page_no: this.pageno.toString()
                };
                break;
            case 'name':
                this.body = {
                    name: gdata,
                    records_per_page: grow.toString(),
                    page_no: this.pageno.toString()
                };
                break;
        }
        this.lookupservice
            .searchDoctorsDetails(this.body)
            .then((sdata) => {
                if (sdata == true) {
                    this.getDetails();
                }
            })
            .catch((error) => {
                this.e = error.error;
            });
    }

    selectDoctor(lookup) {
        this.selectedDoctor = lookup;
        this.lookupservice.setSelectedDoctor(this.selectedDoctor);
        this.router.navigate(['/' + this.slug + '/doctor/lookup-display-d'], { queryParams: { user_guid: this.selectedDoctor.user_guid } });
    }

    ngOnInit(): void {
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Lookup Screen' },
            { label: 'Lookup Doctors' },
            { label: 'Lookup List' }
        ]);
        this.route.queryParamMap.subscribe(async (res) => {

            let searchType = res.get('searchType');
            let searchdata = res.get('searchData');
            this.searchbody1.current_user_guid = sessionStorage.getItem('userid');
            this.searchbody1.page_no = 1;
            this.searchbody1.records_per_page = 100;
            if (searchType === 'e_email') {
                this.searchbody1.e_email = searchdata;
            }
            if (searchType === 'name') {
                this.searchbody1.name = searchdata;
            }

        });
        this.lookupservice
            .searchDoctorsDetails(this.searchbody1)
            .then((resp) => {
                if (resp) {
                    this.getDetails();
                }
            })
            .catch((error) => (this.e = error.error.message));
        this.cols = [
            { field: 'first_name', header: 'First Name' },
            /*   {field: 'middle_name', header: 'Middle Name'}, */
            { field: 'last_name', header: 'Last Name' },
            { field: 'd_email', header: 'Email' },
            { field: 'check', header: 'Check' }
        ];

    }

    getDetails() {
        this.loading = true;
        this.lookuplist = this.lookupservice.displayDoctorsDetails();
        this.totalRecords = this.lookuplist.data.doctors.count;
        this.multirecord = [...this.lookuplist.data.doctors.rows];
        this.loading = false;
    }

    loadCustomers(event: LazyLoadEvent) {
        this.loading = true;
        setTimeout(() => {
            if (this.multirecord) {
                this.getpage(this.type, this.data, event.rows, event.first + 1);
                this.loading = false;
            }
        }, 1000);
    }

    prev() {
        this.router.navigate(['/' + this.slug + '/doctor/lookup-search-d']);
    }
}
